import { useCallback } from "react";
import { useSelector } from "react-redux";

import environments from "@/environments";
import { useApi } from "@/hooks/useApi";
import { RootState } from "@/reducers/types";
import { KeepOutArea } from "@/sx-layout/components/plotmap/models";

export const useKeepOutAreaApi = (plotPlanId: number) => {
  const api = useApi();

  const layoutDate = useSelector<RootState, Date>((state) => state.plotmap.layoutDate);

  const fetchKeepOutAreas = async (): Promise<GetKeepOutAreasResponse | undefined> => {
    const dateStr = convertLayoutDate(layoutDate);
    const endpoint = `${environments.API_BASE_URI}/plot_plans/${plotPlanId}/keepout_areas?layout_date=${dateStr}`;
    return api.get(endpoint);
  };

  const convertLayoutDate = useCallback((layout_date: Date) => {
    return `${layout_date.getFullYear()}-${(layout_date.getMonth() + 1).toString().padStart(2, "0")}-${layout_date
      .getDate()
      .toString()
      .padStart(2, "0")}`;
  }, []);

  return { fetchKeepOutAreas } as const;
};

type GetKeepOutAreasResponse = { keepout_areas: KeepOutArea[] };
